exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filters[data-v-6164d375] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ebeef5;\n}\n.el-button[data-v-6164d375] {\n  margin-left: 30px;\n}\n.el-table .cell[data-v-6164d375] {\n  line-height: 23px;\n}\n.el-input[data-v-6164d375] {\n  width: 200px;\n}\n.bg-dark[data-v-6164d375] {\n  background: #80c1ff;\n}\n.bg[data-v-6164d375] {\n  background: #cce6ff;\n}\n.bg-light[data-v-6164d375] {\n  background: #e6f3ff;\n}\n.el-form-item__label[data-v-6164d375] {\n  text-align: right;\n  float: left;\n  font-size: 14px;\n  color: #606266;\n  line-height: 20px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.el-form-item[data-v-6164d375] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n  padding-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6164d375","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ConsultantsList.vue
// module id = 7trx
// module chunks = 1